/* eslint-disable camelcase */
// import * as srv from './srv'

window.abs = {}

export let assets = []
window.abs.assets = assets

export let user = {}
window.abs.user = user

export function get_browser_id () {
  return window.localStorage.b
}
export function get_user_id () {
  return window.localStorage.u
}

export function set_browser_id (browser_id) {
  window.localStorage.b = browser_id
}
export function set_user_id (user_id) {
  window.localStorage.u = user_id
}

export function clear () {
  window.abs.assets = []
  window.abs.user = {}
  delete window.localStorage.b
  delete window.localStorage.u
  console.log(window.abs)
}



// WEBPACK FOOTER //
// ./src/storage.js